var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapMap',{ref:"gmap",staticClass:"map",attrs:{"center":_vm.center,"zoom":_vm.zoom,"mapTypeId":_vm.mapTypeId,"options":_vm.google && _vm.mapOptions},on:{"click":_vm.onMapClicked,"dragend":_vm.onDragEnd}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }